import lang from "@/views/modules/UserReports/language/en";
import breadcrumbs from "@/views/modules/UserReports/MenuList.vue";

export default {
    name: "list-user-report",
  
    components: {
        breadcrumbs,
    },
    data() {
        return {
            lang: [],
            filterData: {},
        }
    },
    mounted() {
        this.lang = lang;
    },
    methods: {
        clearFilters() {
            this.filterData = {};
        },
    }
}